'use client'

import {
  Col,
  getBankDetailsFromCardNumberOrEnName,
  Row,
  Typography,
} from '@repo/ui/components'

import { useMemo } from 'react'

interface CardsItemProps {
  enName: string
  card?: string
  sheba?: string
  showBankName?: boolean
}

export const CardsItem = ({
  enName,
  card,
  sheba,
  showBankName = true,
}: CardsItemProps) => {
  const bankDetails = useMemo(() => {
    return getBankDetailsFromCardNumberOrEnName(card, enName)
  }, [enName, card])
  return (
    <Row className='gap-md w-fit'>
      {bankDetails?.icon}
      <Col className='w-fit'>
        <Row className='gap-2xs w-fit'>
          {showBankName && (
            <Typography
              size='sm'
              weight='bold'
              color='text-neutral-surface-100'
            >
              {bankDetails?.name}
            </Typography>
          )}
          {card && (
            <Typography
              size='sm'
              weight='regular'
              color='text-neutral-surface-100'
            >
              {card}
            </Typography>
          )}
        </Row>
        {sheba && (
          <Typography
            size='xs'
            weight='regular'
            color='text-neutral-surface-60'
            variant='bdi'
            className='text-end'
          >
            IR {sheba.replace('IR', '')}
          </Typography>
        )}
      </Col>
    </Row>
  )
}
